import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '/radios', pathMatch: 'full' },
  {
    path: 'radios',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/radios-view/radios-view.component').then(
        (m) => m.RadiosViewComponent,
      ),
  },
  {
    path: 'now-playing/:title',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/now-playing-view/now-playing-view.component').then(
        (m) => m.NowPlayingViewComponent,
      ),
  },
  {
    path: 'radio/:slug',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/radio-detail/radio-detail.component').then(
        (m) => m.RadioDetailComponent,
      ),
  },
  {
    path: 'favorites',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/favorites-view/favorites-view.component').then(
        (m) => m.FavoritesViewComponent,
      ),
  },
  {
    path: 'settings',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/settings-view/settings-view.component').then(
        (m) => m.SettingsViewComponent,
      ),
  },
  {
    path: 'equalizer',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/equalizer-view/equalizer-view.component').then(
        (m) => m.EqualizerViewComponent,
      ),
  },
  {
    path: 'radios/:category',
    loadComponent: () =>
      import(
        './components/radio-in-category-gridview/radio-in-category-gridview.component'
      ).then((m) => m.RadioCategoryGridviewComponent),
  },
  {
    path: 'copyrights-and-privacy-policy',
    loadComponent: () =>
      import(
        './components/copyrights-and-privacy-policy-view/copyrights-and-privacy-policy-view.component'
      ).then((m) => m.PrivacyPolicyAndCopyrightsViewComponent),
  },
  { path: '**', redirectTo: '/radios' },
];
